import axios from 'axios';
import Cookies from 'js-cookie';
import config from '../../config';


const Endpoint = '/api/detalle_visita_por_tipo/';


const api = axios.create({
  baseURL: config.baseUrl,
});

api.interceptors.request.use(
  (config) => {
    const token = Cookies.get('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const getDetalleVisitaPorTipo = async (tipo_visita, email) => {
  try {
    const response = await api.post(`${Endpoint}`, {
      tipo_visita,
      email,
    });
    return response.data;
  } catch (error) {
    console.error('Error al obtener detalle de las visitas', error);
    throw error;
  }
};

export default getDetalleVisitaPorTipo;